import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import InfoPopupModal from '../infoPopupModal';
import { useDispatch } from 'react-redux';
import { setIsOnline, setShowOfflineMessage } from '../../Redux/Reducers/appConfigReducer';

const OfflineModal = () => {
  const  { t } = useTranslation();
  const dispatch = useDispatch();

  const onContinue = () => {
    dispatch(setShowOfflineMessage(false));
  };


  return (
    <>
      <InfoPopupModal 
        title={t('offlineModal.title')}
        subtitle={t('offlineModal.subtitle')}
        primaryBtnLabel={t('offlineModal.primary_button')}
        onContinue={onContinue}
        OnRequestClose={onContinue}
      />
    </>
  );
};
 
export default OfflineModal;
